import { Button, Card, CardActionArea, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

const WishListCard = ({ url, image, category, name, price, discount, rows, removeFromWishList }) => {
  return (
    <>
      <Card elevation={0}>
        <CardActionArea component={Link} to={`/dataset-detail/${url}`}>
          <CardMedia component='img' alt='item card' height='180' image={`${process.env.REACT_APP_s3_cdn}/${process.env.REACT_APP_STAGE}/cover_images/${image}`} />
          <CardContent sx={{ height: '150px' }}>
            <Typography variant='caption'>{category}</Typography>
            <Typography variant='subtitle2'>
              {name} ({rows} Rows){' '}
            </Typography>
            <div style={{ display: 'flex', margin: '1em 0', gap: 5 }}>
              <Typography variant='subtitle1' color='secondary'>
                ৳&nbsp;{price - discount}
              </Typography>
              {discount !== 0 && (
                <Typography variant='subtitle1' sx={{ textDecoration: 'line-through', color: '#B4B4B4' }}>
                  ৳&nbsp;{price}
                </Typography>
              )}
            </div>
          </CardContent>
        </CardActionArea>
        <CardActions>
          <Button fullWidth variant='contained' color='error' disableElevation onClick={() => removeFromWishList(url)}>
            Remove From Wishlist
          </Button>
        </CardActions>
      </Card>
    </>
  );
};

export default WishListCard;
